var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDscSorted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92729 0.177677L3.49687 2.53455L1.06644 0.177677C0.822148 -0.0592255 0.427517 -0.0592255 0.183221 0.177677C-0.0610738 0.414579 -0.0610738 0.797266 0.183221 1.03417L3.05839 3.82232C3.30269 4.05923 3.69732 4.05923 3.94161 3.82232L6.81678 1.03417C7.06107 0.797266 7.06107 0.414579 6.81678 0.177677C6.57248 -0.0531511 6.17159 -0.0592255 5.92729 0.177677Z",
    fill: "#353434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDscSorted);
export default __webpack_public_path__ + "static/media/dsc-sorted.da2072b239d4623a71daa5670751de2b.svg";
export { ForwardRef as ReactComponent };